
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/physical-therapists-us",
      function () {
        return require("private-next-pages/partner/physical-therapists-us.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/physical-therapists-us"])
      });
    }
  